<template>
  <vs-popup title="Virtual Job Experience" :active.sync="helpPopupVisible">
    <h4 class="mb-5">Get Help/Report a Problem</h4>

    <p class="mb-5">
      If you have a problem with any part of the Virtual Job Experience, fill out the form below and
      submit it and we will get back to you with help really quickly.
    </p>

    <vs-input
      autocomplete="name"
      class="w-full"
      label-placeholder="Your Name"
      v-model="name"
      v-validate="'required'"
      name="name"
    ></vs-input>
    <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>

    <vs-input
      autocomplete="organization"
      class="w-full mt-8"
      label-placeholder="Your School"
      v-model="school"
      v-validate="'required'"
      name="school"
    ></vs-input>
    <span class="text-danger text-sm" v-show="errors.has('school')">{{
      errors.first('school')
    }}</span>

    <vs-input
      autocomplete="email"
      class="w-full mt-8"
      label-placeholder="Email Address"
      v-model="email"
      v-validate="'required|email'"
      name="email"
    ></vs-input>
    <span class="text-danger text-sm" v-show="errors.has('email')">{{
      errors.first('email')
    }}</span>

    <vs-input
      class="w-full mt-8"
      label-placeholder="Mobile Number"
      v-model="phone"
      name="phone"
    ></vs-input>
    <span class="text-danger text-sm" v-show="errors.has('phone')">{{
      errors.first('phone')
    }}</span>

    <vs-textarea
      rows="6"
      class="w-full mt-8"
      placeholder="Description of your issue/problem"
      v-model="issue"
      v-validate="'required'"
      name="issue"
    ></vs-textarea>
    <span class="text-danger text-sm" v-show="errors.has('issue')">{{
      errors.first('issue')
    }}</span>

    <div class="flex flex-wrap items-center justify-end">
      <form @submit.prevent="validateForm">
        <button class="btn btn-primary btn-size-medium ml-auto mt-2">Submit</button>
      </form>
    </div>
    <vs-progress indeterminate color="primary" v-if="sending"></vs-progress>
  </vs-popup>
</template>

<script>
import store from '@/store/store';
import theApi from '@/mixins/theApi';
export default {
  data() {
    return {
      name: '',
      email: '',
      school: '',
      phone: '',
      issue: '',
      sending: false,
    };
  },
  computed: {
    helpPopupVisible: {
      get: function () {
        return this.$store.getters['popup/helpPopupVisible'];
      },
      set: function (d) {
        this.$store.commit('popup/setHelpPopupVisible', d);
      },
    },
    Cname() {
      return store.getters['authStudent/studentName'];
    },
    Cemail() {
      return store.getters['authStudent/email'];
    },
    Cschool() {
      return store.getters['authStudent/school'];
    },
  },
  methods: {
    validateForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitForm();
        }
      });
    },
    async submitForm() {
      const formData = new FormData();
      formData.append('name', this.name);
      formData.append('email', this.email);
      formData.append('school', this.school);
      formData.append('phone', this.phone);
      formData.append('issue', this.issue);

      this.sending = true;
      theApi.methods
        .makeCall(
          false,
          'help/submit',
          'post',
          formData,
          'Thankyou for letting us know about this. We will be in touch really quickly to help you.',
          true,
        )
        .then(
          () => {
            this.sending = false;
            this.name = '';
            this.email = '';
            this.school = '';
            this.issue = '';
            this.phone = '';

            this.$nextTick(() => {
              this.errors.clear();
              this.$nextTick(() => {
                this.$validator.reset();
              });
            });
            store.commit('popup/setHelpPopupVisible', false);
          },
          () => {
            this.sending = false;
          },
        );
    },
  },
  mounted() {
    this.name = this.Cname;
    this.email = this.Cemail;
    this.school = this.Cschool;
  },
  watch: {
    Cname() {
      this.name = this.Cname;
    },
    Cemail() {
      this.email = this.Cemail;
    },
    Cschool() {
      this.school = this.Cschool;
    },
  },
};
</script>
